import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./AddCategory.css";
import Editor from "../../../components/admin/Editor";
import { BACKEND_URL } from "../../../config";

// const BACKEND_URL ;

function AddCategory() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    categoryName: "",
    slug: "",
    description: "",
    metaTitle: "",
    metaDescription: "",
    keywords: "",
    status: "Active",
    date: "",
    parentId: "",
  });

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api.php?module=category`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setCategories(data.data.filter((c) => c.status === "Active"));
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
  const generatedSlug = formData.categoryName
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");

  setFormData((prev) => ({
    ...prev,
    slug: generatedSlug,
  }));
}, [formData.categoryName]);

 
 const [imagePreview, setImagePreview] = useState(null);
 const [file, setFile] = useState(null);
  const [keywordInput, setKeywordInput] = useState("");
  const [keywordList, setKeywordList] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= INPUT =================
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ================= KEYWORDS =================
  const handleKeywordKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();

      const value = keywordInput.trim();

      if (value && !keywordList.includes(value)) {
        const updated = [...keywordList, value];

        setKeywordList(updated);
        setFormData({
          ...formData,
          keywords: updated.join(","),
        });
      }

      setKeywordInput("");
    }
  };

  const removeKeyword = (index) => {
    const updated = keywordList.filter((_, i) => i !== index);

    setKeywordList(updated);
    setFormData({
      ...formData,
      keywords: updated.join(","),
    });
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();

      form.append("action", "add");
      form.append("categoryName", formData.categoryName);
      form.append("slug", formData.slug);
      form.append("description", formData.description);
      form.append("metaTitle", formData.metaTitle);
      form.append("metaDescription", formData.metaDescription);
      form.append("keywords", formData.keywords);
      form.append("status", formData.status);
      form.append("date", formData.date);
      form.append("parentId", formData.parentId || "");
      form.append("parent_id", formData.parentId || "");
      // image upload
      if (file) {
          form.append("image", file);
        }

      const response = await fetch(
        `${BACKEND_URL}/api.php?module=category`,
        {
          method: "POST",
          body: form,
        }
      );

      const text = await response.text();
        console.log("RAW RESPONSE:", text);

        let result;

        try {
          result = JSON.parse(text);
        } catch (e) {
          console.error("Invalid JSON:", text);
          alert("Backend error");
          return;
        }

      if (result.success) {
        alert("Category added successfully ✔");

        setFormData({
          categoryName: "",
          slug:"",
          description: "",
          metaTitle: "",
          metaDescription: "",
          keywords: "",
          status: "Active",
          date: "",
          parentId: "",
        });

        setFile(null);
        setImagePreview(null);
        
        setKeywordList([]);
        setKeywordInput("");

        navigate("/admin/categories/view");
      } else {
        alert(result.message || "Failed to add category");
      }
    } catch (error) {
      console.error(error);
      alert("Backend error");
    } finally {
      setLoading(false);
    }
  };

  // ================= UI =================
  return (
    <div className="add-category-page">
      <h2>Add Category</h2>

      <form onSubmit={handleSubmit}>

        {/* CATEGORY NAME */}
        <label>Category Name</label>
        <input
          name="categoryName"
          placeholder="Category Name"
          value={formData.categoryName}
          onChange={handleChange}
          required
        />

        <label>Slug</label>
          <input
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            placeholder="Slug"
          />

        <label>Date</label>
        <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />

        <label>Parent Category (Optional)</label>
        <select
          name="parentId"
          value={formData.parentId}
          onChange={handleChange}
        >
          <option value="">None (Is a Parent Category)</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>
              {c.categoryName}
            </option>
          ))}
        </select>

        {/* DESCRIPTION */}
        <label>Description</label>

        <Editor
            formData={formData}
            setFormData={setFormData}
            field="description"
          />

        {/* META TITLE */}
        <label>Meta Title</label>
        <input
          name="metaTitle"
          placeholder="Meta Title"
          value={formData.metaTitle}
          onChange={handleChange}
        />

        {/* META DESCRIPTION */}
        <label>Meta Description</label>
        <textarea
          name="metaDescription"
          placeholder="Meta Description"
          value={formData.metaDescription}
          onChange={handleChange}
        />

        {/* KEYWORDS */}
        <label>Keywords</label>
        <input
          type="text"
          placeholder="Enter keyword + Enter"
          value={keywordInput}
          onChange={(e) => setKeywordInput(e.target.value)}
          onKeyDown={handleKeywordKeyDown}
        />

        <div className="keyword-box">
          {keywordList.map((k, i) => (
            <span
              key={i}
              onClick={() => removeKeyword(i)}
              className="keyword-tag"
            >
              {k} ✖
            </span>
          ))}
        </div>

        {/* IMAGE */}
        <label>Image</label>
        <input
          type="file"
          accept=".webp,image/webp"
          onChange={(e) => {
            const file = e.target.files[0];

            if (file) {
              // extra validation (security)
              if (file.type !== "image/webp") {
                alert("Only WEBP images are allowed ❌");
                return;
              }

              setFile(file);
              setImagePreview(URL.createObjectURL(file));
            }
          }}
          />

        {imagePreview && <img src={imagePreview} width="200" alt="" />}


        {/* STATUS */}
        <label>Status</label>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
        >
          <option>Active</option>
          <option>Inactive</option>
        </select>

        {/* SUBMIT */}
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Add Category"}
        </button>

      </form>
    </div>
  );
}

export default AddCategory;